import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectErrorMessage } from '../../ducks/genericError';
import {
  boxShadow, darkRed,
} from '../../styles/constants';

const StyledDiv = styled.div`
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  bottom: 20px;
  z-index: 999;
  border: 2px solid ${darkRed};
  border-left: 5px solid ${darkRed};
  width: 350px;
  padding: 0.5rem;
  background-color: white;
  border-radius: 5px;
  box-shadow: ${boxShadow};
  display: ${(props) => (props.show ? 'flex' : 'none')};
  word-break: break-word;
`;

const CenterVertically = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0.5rem 0 0 ;
`;

const Error = styled.span`
  display: block;
  font-weight: 600;
  font-size: 0.9rem;
`;

const Message = styled.span`
  font-weight: 600;
  opacity: 0.6;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${darkRed};
`;

const GenericError = () => {
  const errorMessage = useSelector(selectErrorMessage);

  return (
    <StyledDiv show={errorMessage}>
      <CenterVertically>
        <StyledFontAwesomeIcon
          icon="times-circle"
          size="2x"
        />
      </CenterVertically>
      <div>
        <Error>Error</Error>
        <Message>{errorMessage}</Message>
      </div>
    </StyledDiv>
  );
};

export default GenericError;
